import React, { Fragment } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useFormikContext } from 'formik';

import { FieldBuilder } from '@components/Forms';
import { DOCUMENTS_TO_HIDE } from '@config/const';

export const ProfileDocumentsForm = ({ documents, templates, profileID }) => {
  const navigate = useNavigate();
  const builder = new FieldBuilder(useFormikContext());
  const [searchParams, _] = useSearchParams();
  const documentsTitle = searchParams.get('plan')
    ? 'Required Documents for this Plan'
    : 'All Documents';
  const data = documents.filter(({ id }) => !DOCUMENTS_TO_HIDE.includes(id));
  return (
    <>
      <Row className="mb-2">
        <div className="text-center">{documentsTitle}</div>
      </Row>
      <hr />
      <Row className="mb-3">
        <div className="text-center">
          <Button
            variant="didxl"
            size="sm"
            onClick={() =>
              navigate('/profiles/documents', {
                state: { profileID, showExit: true },
              })
            }
          >
            View existing documents
          </Button>
        </div>
      </Row>
      {data.map(
        ({ label, id, multiple, info, new_version_required: requiredNew }) =>
          builder.renderDocumentField(label, id, multiple, info, requiredNew)
      )}
      <Row className="textRed">
        <Col>
          When uploading documents <b>save end user</b> is needed to store the
          new document.
        </Col>
      </Row>
      {templates && templates.length > 0
        ? templates.map((item) => (
            <Fragment key={item.location}>
              <Row className="mt-3">
                <Col className="text-center">Download empty template</Col>
              </Row>
              <Row className="mt-3">
                <Col sm={6}>{item.label}</Col>
                <Col sm={6}>
                  <Col md={9}>
                    <Button
                      as="a"
                      className="w-100"
                      variant="didxl"
                      size="sm"
                      href={item.location}
                      target="_blank"
                    >
                      Download
                    </Button>
                  </Col>
                </Col>
              </Row>
            </Fragment>
          ))
        : null}
    </>
  );
};
